import { createContext } from 'react';

const Context = createContext<string[] | undefined>(undefined);
export default Context;
